import { Card, CardBody, TableControl, TableSkeleton } from '@/_components';

import { ContainerLayout } from './containers';

import { StickyPageHeaderSkeletonWithButtons } from '../headers';

export function TabularPageLoadingLayout({
  numberOfColumns,
  numberOfButtons = 1,
}: {
  numberOfColumns: number;
  numberOfButtons?: number;
}) {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={numberOfButtons} />

      <div className="mt-2 px-6">
        <Card>
          <CardBody className="space-y-4">
            <TableControl />

            <TableSkeleton numberOfColumns={numberOfColumns} />
          </CardBody>
        </Card>
      </div>
    </ContainerLayout>
  );
}
